import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IndicatorsListComponent } from './Pages/Indicators/List/IndicatorsList'
import { HandbooksListComponent } from './Pages/Handbooks/HandbooksList';
import { IndicatorsPeriodicityListComponent } from './Pages/Indicators/Periodicities/IndicatorsPeriodicityList'
import { IndustriesHandbookComponent } from './Pages/Handbooks/Industries/Industries';
import { HomeIndexComponent } from './Pages/Home/Index';
import { IndicatorsPlannedListComponent } from './Pages/Indicators/Planned/IndicatorsPlannedList';
import { IndicatorsPublicListComponent } from './Pages/Indicators/Public/IndicatorsPublicList';
import { RoleActivator, UserActivator, AdminActivator } from './Activators/RoleActivator';

const routes: Routes = [
    { path: '',  component: HomeIndexComponent, canActivate: [] },
    { path: 'main-page',  component: HomeIndexComponent, canActivate: [] },
    { path: 'LoginCallback', component: HomeIndexComponent, canActivate: []},

    { path: 'Indicators/List', component: IndicatorsListComponent, canActivate: [] },
    { path: 'FactorsPeriods/:PeriodicityId', component: IndicatorsPeriodicityListComponent, canActivate: [] },
    { path: 'Indicators/Planned', component: IndicatorsPlannedListComponent, canActivate: [] },
    { path: 'Indicators/Public', component: IndicatorsPublicListComponent, canActivate: [] },
    { path: 'Handbooks/:HandbookId', component: HandbooksListComponent, canActivate: [] },
    { path: 'HandbooksIndustries', component: IndustriesHandbookComponent, canActivate: []},
    
    { path: 'admin-only',  component: HomeIndexComponent, canActivate: [AdminActivator] },

];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    providers: [AdminActivator, UserActivator, RoleActivator],
    exports: [RouterModule]
})
export class AppRoutingModule {
    constructor() {}
}